import React, { useState } from "react";
import { toast } from "react-toastify";
import Loader from "../../components/common/Loader";
import { openInNewTab } from "../../utils/openInNewTab";
const Holiday = () => {

  const [loading,setLoading]=useState(false)
const handleDownload = (year) => {
  const fileUrl = `https://crm.technotackle.in/holidays/${year}.pdf`;
  setLoading(true);

  try {
    openInNewTab(fileUrl);
    // toast.success(`${year} Holiday PDF opened successfully`);
  } catch (error) {
    toast.error("Failed to open PDF");
  } finally {
    setLoading(false);
  }
};


  return (
    <>
    {loading ?<Loader/> :
    
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ height: "600px" }}
    >

      <div className="p-5 text-center" style={{ width: "400px" }}>
        <h1 className="h4 fw-bold mb-4">Select Year to View  Holiday Chart</h1>

        <div className="row g-3">
          {[2026, 2025, 2024, 2023].map((year) => (
            <div className="col-6" key={year}>
              <button
                className="add_btn w-100 py-3 fw-semibold"
                onClick={() => handleDownload(year)}
              >
                {year}
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
}
    </>
  );
};

export default Holiday;
